import { cn } from "@/lib/utils";

interface StatusBadgeProps {
  status: string;
  color: string;
  className?: string;
}

export function StatusBadge({ status, color, className = '' }: StatusBadgeProps) {
  return (
    <aside className={cn(
      "flex-shrink-0 rounded-lg border border-[#484848] px-4 py-1 font-semibold text-white text-center",
      color,
      className
    )}>
      {status}
    </aside>
  );
}
